import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";

const Chapter8_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Welche Einrichtungen zählen zu den KRITIS-Betreibern?",
      options: [
        {
          value: "A",
          label:
            "Lokale Geschäfte, die ausschließlich regionale Dienstleistungen anbieten.",
        },
        {
          value: "B",
          label:
            "Einrichtungen, deren Ausfall erhebliche Auswirkungen auf die Gesellschaft oder Wirtschaft hätte, wie Energieversorger oder Krankenhäuser.",
        },
      ],
      correct: "B",
    },
    {
      question: "Frage 2: Was ist ein Hauptziel des KRITIS-Regelwerks?",
      options: [
        {
          value: "A",
          label:
            "Den Schutz kritischer Infrastrukturen vor Cyberangriffen und anderen Bedrohungen zu gewährleisten.",
        },
        {
          value: "B",
          label: "Den Aufbau neuer Infrastrukturen in der EU zu fördern.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 8_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
       
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("users").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("users")
            .doc(userId)
            .update({
              lastChapter: "8_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("8_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 8_1.");
        } else {
          
          await db
            .collection("users")
            .doc(userId)
            .set({
              lastChapter: "8_1",
              completedChapters: ["8_1"],
            });
          console.log("Dokument erstellt mit Kapitel 8_1");
        }

        navigate("/8_2"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/course-overview"
                >
                  8. Regulatorische Anforderungen
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                KRITIS
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 8: Regulatorische Anforderungen
          </h3>

          <img
            src="/images/kritis.png"
            alt="KRITIS"
            style={{ position: "relative", maxWidth: "18%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 p-5 mx-auto">
            Die zunehmenden Cyberbedrohungen und die wachsende Abhängigkeit von
            digitalen Technologien haben die EU dazu veranlasst, den Schutz
            kritischer Infrastrukturen (KRITIS) zu verstärken. Dafür wurde
            innerhalb kurzer Zeit eine Vielzahl von Verordnungen, Richtlinien
            und Gesetzesinitativen entwickelt.
            <br />
            <br /> Für den Finanzdienstleistungssektor, der überdurchschnittlich oft Ziel von
            Cyberangriffen ist und für den Schutz sensibler Daten oberste
            Priorität hat, sind vor allem <strong>KRITIS, NIS2 und DORA </strong>{" "}
            relevant. Diese Regelwerke verlangen von Banken und
            Finanzinstituten, gesetzlichen Vorgaben zu erfüllen und
            dadurch ihre Sicherheit und Resilienz zu stärken.
                      </p>
                      <p className="col-lg-11 p-5 mx-auto">
Die bankenaufsichtlichen Anforderungen an die IT (BAIT), die Ende 2026 aufgehoben werden, sowie der Finanzmarktdigitalisierungs- und -innovationsgesetz (FinDIGG) ergänzen die regulatorischen Anforderungen für den Finanzsektor. Sie legen spezifische Anforderungen an die IT-Sicherheit, das Risikomanagement und die Digitalisierung von Finanzdienstleistungen fest. Banken müssen diese Anforderungen erfüllen, um die Sicherheit ihrer Systeme zu gewährleisten und die Integrität des Finanzmarktes zu schützen.

                      </p>
        </div>
        <div>
          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h2 className="p-4">Was ist KRITIS? </h2>
                <p className="col-lg-11 mx-auto">
                  KRITIS ist ein deutscher Rechtsrahmen, der erstellt wurde um
                  das Risiko von Angriffen auf wichtige gesellschaftliche und
                  wirtschaftliche Bereiche zu minimieren. KRITIS steht für{" "}
                  <strong>kritische Infrastrukturen </strong>. Diese umfassen
                  Einrichtungen oder Systeme, die von hoher Bedeutung für das
                  Funktionieren einer Gesellschaft sind. Ein Ausfall oder eine
                  Beeinträchtigung dieser Infrastrukturen kann schwerwiegende
                  Folgen haben, die sowohl die öffentliche Sicherheit als auch
                  die wirtschaftliche Stabilität betreffen.
                  <br />
                  <br />
                  KRITIS unterteilt man in{" "}
                  <strong>Technische Basisinfrastrukturen </strong>{" "}
                  (Energieversorgung, Informationstechnik und Telekommunikation,
                  Transport und Verkehr, Wasser und Abwasser) und{" "}
                  <strong>
                    Sozioökonmische Dienstleistungsinfrastrukturen{" "}
                  </strong>{" "}
                  (Gesundheitswesen, Ernährung, Finanz- und Versicherungswesen
                  Medien sowie Kultur, Staat und Verwaltung). Das Bundesamt für
                  Sicherheit in der Informationstechnik (BSI) legt die Kriterien
                  fest, wer als Teil der kritischen Infrastruktur eingestuft
                  wird.
                  <br />
                  <br />
                  Im Kontext der Cybersecurity spielt KRITIS eine besondere
                  Rolle, da die zunehmende Digitalisierung und Vernetzung
                  kritischer Infrastrukturen sie anfälliger für Cyberangriffe
                  macht. Hackerangriffe auf Stromnetze, Finanzsysteme oder
                  Krankenhäuser sind nicht nur denkbare Szenarien, sondern in
                  der Vergangenheit bereits Realität geworden. Diese Angriffe
                  führen oft zu erheblichen wirtschaftlichen Schäden und
                  gefährden im schlimmsten Fall Menschenleben.
                  <br />
                  <br />
                  Die deutsche Bundesregierung hat mit dem{" "}
                  <strong>IT-Sicherheitsgesetz </strong>
                  und der <strong>KRITIS-Verordnung </strong> einen rechtlichen
                  Rahmen geschaffen, der Betreiber kritischer Infrastrukturen
                  verpflichtet, bestimmte Sicherheitsmaßnahmen zu ergreifen.
                  Diese Maßnahmen zielen darauf ab, die Widerstandsfähigkeit
                  gegenüber Cyberbedrohungen zu erhöhen und die Verfügbarkeit,
                  Integrität und Vertraulichkeit der Systeme sicherzustellen.
                </p>

                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Im Finanzdienstleistungssektor zählen vor allem größere
                  Finanzinstitute mit einem bedeutenden Marktanteil zu KRITIS,
                  die zentrale Dienstleistungen wie Zahlungsverkehr,
                  Kreditvergabe und den Wertpapierhandel bereitstellen. Diese
                  Unternehmen sind für die Aufrechterhaltung eines stabilen und
                  sicheren Finanzsystems verantwortlich und müssen daher
                  besondere Sicherheitsanforderungen erfüllen.
                </p>
              </div>
            </div>
          </div>

          <div className="gelb-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h2 className="col-lg-11 p-5 text-center mx-auto">
                  KRITIS-Sicherheitsanforderungen
                </h2>

                <p className="col-lg-11 text-center mx-auto">
                  Ein wichtiges Element der KRITIS-Sicherheitsanforderungen
                  ist die regelmäßige Durchführung von Risikoanalysen und die
                  Umsetzung geeigneter technischer und organisatorischer
                  Maßnahmen. Darüber hinaus sind Betreiber verpflichtet,
                  Cyberangriffe oder Sicherheitsvorfälle an das Bundesamt für
                  Sicherheit in der Informationstechnik (BSI) zu melden.
                </p>
                <h4 className="pt-5">Technische Schutzmaßnahmen</h4>
                <p className="col-lg-11 pt-3 text-center mx-auto">
                  <strong>Netzwerksicherheit und Zugangskontrollen: </strong>{" "}
                  Finanzinstitute müssen{" "}
                  <Link to="/4_3#firewall" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    Firewalls
                  </Link>{" "}
                  und Intrusion-Detection-Systeme (
                  <Link to="/4_3#ids" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    IDS
                  </Link>
                  ) implementieren, um unbefugten Zugriff zu verhindern und
                  Angriffe frühzeitig zu erkennen.
                  <br />
                  <br />
                  <strong>
                    {" "}
                    <Link to="/4_4" className="icon-link">
                      {" "}
                      <svg className="bi" aria-hidden="true">
                        {" "}
                        <use xlinkHref="#book"></use>{" "}
                      </svg>{" "}
                      Datenverschlüsselung{" "}
                    </Link>{" "}
                    :{" "}
                  </strong>{" "}
                  Sämtliche sensiblen Daten müssen verschlüsselt werden, sowohl
                  bei der Übertragung, als auch bei der Speicherung. Dadurch wird
                  gewährleistet, dass Daten auch bei einem unbefugten Zugriff
                  nicht einfach ausgelesen werden können.
                  <br />
                  <br />
                  <strong>
                    Sicherheitsupdates und Patch-Management:{" "}
                  </strong>{" "}
                  Systeme und Software müssen regelmäßig aktualisiert werden, um
                  bekannte Schwachstellen zu schließen und Angriffsrisiken zu
                  minimieren. Dies umfasst ein strukturiertes Patch-Management
                  und die ständige Aktualisierung von Sicherheitssoftware.
                  <br />
                  <br />
                  <strong>
                    Sicherungsmaßnahmen ({" "}
                    <Link to="/3_2#backup" className="icon-link">
                      <svg className="bi" aria-hidden="true">
                        <use xlinkHref="#book"></use>
                      </svg>{" "}
                      Backups
                    </Link>{" "}
                    ):{" "}
                  </strong>{" "}
                  Regelmäßige Datensicherungen sind notwendig, um im Falle eines
                  Angriffs, wie etwa durch{" "}
                  <Link to="/2_4" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    Phishing{" "}
                  </Link>{" "}
                  , den Betrieb schnell wiederherstellen zu können. Diese
                  Backups müssen sicher und getrennt von den Hauptsystemen
                  aufbewahrt werden.
                </p>
                <h4 className="pt-5">Organisatorische Schutzmaßnahmen</h4>
                <p className="col-lg-11 pt-3 text-center mx-auto">
                  <strong>Notfall- und Krisenmanagement: </strong> Unternehmen
                  müssen Notfallpläne vorhalten, die den Umgang mit
                  Sicherheitsvorfällen und Störungen regeln. Dazu gehört auch
                  die Einbindung eines Incident-Response-Teams, das im Ernstfall
                  sofortige Maßnahmen ergreifen kann.
                  <br />
                  <br />
                  <strong>Risikomanagement: </strong> Finanzinstitute sind
                  verpflichtet, regelmäßig Risikoanalysen durchzuführen, um
                  potenzielle Bedrohungen ihrer IT-Infrastruktur zu
                  identifizieren und zu bewerten. Diese Risikoanalysen helfen,
                  Sicherheitsstrategien gezielt anzupassen und zu verbessern.
                  <br />
                  <br />
                  <strong>
                    Schulung und Sensibilisierung der Mitarbeiter:{" "}
                  </strong>{" "}
                  Mitarbeiter sind oft eine Schwachstelle in der
                  Sicherheitskette, daher müssen sie regelmäßig zu Themen wie{" "}
                  <Link to="/2_4" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    Phishing,{" "}
                  </Link>
                  <Link to="/2_5" className="icon-link">
                    {" "}
                    <svg className="bi" aria-hidden="true">
                      {" "}
                      <use xlinkHref="#book"></use>{" "}
                    </svg>{" "}
                    Social Engineering{" "}
                  </Link>{" "}
                  und sicherem Verhalten im Umgang mit sensiblen Daten geschult
                  werden. Awareness-Programme helfen, das Sicherheitsbewusstsein
                  im Unternehmen zu stärken.
                  <br />
                  <br />
                  <strong>
                    Externe Sicherheitsüberprüfungen und Audits:{" "}
                  </strong>{" "}
                  Finanzinstitute, die unter KRITIS fallen, müssen regelmäßig
                  externe Sicherheitsüberprüfungen und{" "}
                  <Link to="/2_1#pentest" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    Penetrationstests
                  </Link>
                  durchführen lassen, um die Wirksamkeit ihrer
                  Sicherheitsmaßnahmen zu testen und potenzielle Schwachstellen
                  aufzudecken.
                </p>
                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Die Deutsche Flugsicherung (DFS) wurde Ziel eines
                  Cyberangriffs, der die IT-Systeme der Flugsicherung bedrohte.
                  Solche Angriffe sind besonders gefährlich, da sie die
                  Sicherheit des Luftverkehrs gefährden können. Die Deutsche
                  Flugsicherung spielt eine zentrale Rolle bei der Koordination
                  von Flugbewegungen im deutschen Luftraum. Ein Angriff auf ihre
                  Systeme könnte zu Flugverspätungen, Umleitungen oder im
                  schlimmsten Fall zu Flugausfällen führen. Dieser Vorfall ist
                  ein Beispiel dafür, wie Angriffe kritische Infrastrukturen
                  massiv stören und weitreichende wirtschaftliche und
                  gesellschaftliche Konsequenzen nach sich ziehen können. (DFS
                  2024)
                </p>
              </div>
            </div>
          </div>

          <div className="grey-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h2 className="p-5">
                  Meldepflichten und Vorfallberichterstattung an das BSI
                </h2>
                <p className="col-lg-11 mx-auto">
                  Im Rahmen des KRITIS-Regelwerks sind Unternehmen, die als
                  Betreiber kritischer Infrastrukturen eingestuft sind, dazu
                  verpflichtet, Sicherheitsvorfälle unverzüglich an das{" "}
                  <strong>
                    {" "}
                    Bundesamt für Sicherheit in der Informationstechnik (BSI){" "}
                  </strong>{" "}
                  zu melden.
                  <br />
                  <br />
                  Die Meldung umfasst eine Beschreibung des Vorfalls, das Ausmaß
                  der Beeinträchtigung, die bereits ergriffenen Maßnahmen sowie
                  die potenziellen Auswirkungen auf den Betrieb und die Kunden.
                  <br />
                  <br />
                  Diese detaillierten Informationen ermöglichen es dem BSI, ein
                  umfassendes Bild des Vorfalls zu erhalten und gezielte
                  Handlungsempfehlungen zu geben oder direkt unterstützend tätig
                  zu werden.
                </p>{" "}
                <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                  <img
                    src="/images/fact.svg"
                    alt="Transparent"
                    style={{
                      position: "relative",
                      maxWidth: "8%",
                      height: "auto",
                    }}
                  />
                  Die Meldepflicht stellt sicher, dass potenziell schwerwiegende
                  Bedrohungen schnell erkannt und Maßnahmen zur
                  Schadensbegrenzung und Prävention auf nationaler Ebene
                  koordiniert werden können.
                </p>
              </div>
            </div>
          </div>

          <div className="white-section">
            <div className="container p-5">
              <div className="p-5 ">
                <h2 className="col-lg-11 p-5 text-center mx-auto">
                  Konsequenzen bei Nichteinhaltung und mögliche Sanktionen
                </h2>

                <p className="col-lg-11 pt-3 text-center mx-auto">
                  Die Nichteinhaltung der KRITIS-Anforderungen kann für Betreiber
                  kritischer Infrastrukturen erhebliche Folgen haben, z. B. Probleme sowie finanzielle Verluste.
                </p>
                <h5 className="pt-5">
                  <strong>Bußgelder und finanzielle Strafen</strong>
                </h5>
                <p className="col-lg-11 pt-3 text-center mx-auto">
                  Verstöße gegen die KRITIS-Vorgaben führen zu empfindlichen
                  Bußgeldern, deren Höhe sich nach der Schwere und Häufigkeit
                  der Verstöße richtet. Sie sollen die Dringlichkeit der
                  Sicherheitsmaßnahmen verdeutlichen und die Unternehmen zur
                  Einhaltung der Vorgaben bewegen.
                </p>
                <h5 className="pt-5">
                  <strong>Verlust der Betriebserlaubnis</strong>
                </h5>
                <p className="col-lg-11 pt-3 text-center mx-auto">
                  Bei systematischer Missachtung grundlegender
                  Sicherheitsanforderungen oder wiederholten Verstößen kann der
                  Entzug der Betriebserlaubnis drohen. Diese Maßnahme ist
                  drastisch, unterstreicht jedoch die Notwendigkeit, die
                  Stabilität kritischer Infrastrukturen sicherzustellen.
                </p>

                <h5 className="pt-5">
                  <strong>Reputationsschaden und Vertrauensverlust</strong>
                </h5>
                <p className="col-lg-11 pt-3  text-center mx-auto">
                  Ein Verstoß gegen Sicherheitsvorgaben kann das Vertrauen von
                  Kunden, Partnern und Investoren nachhaltig schädigen. Gerade
                  im Finanzsektor sind Zuverlässigkeit und Sicherheit
                  essenziell. Ein Reputationsverlust gefährdet die
                  Kundenbindung und kann langfristige wirtschaftliche
                  Folgen haben.
                </p>
                <h5 className="pt-5">
                  <strong>
                    Verstärkte Aufsicht und verschärfte Kontrollen
                  </strong>
                </h5>
                <p className="col-lg-11 pt-3 text-center mx-auto">
                  Aufsichtsbehörden können bei Nichteinhaltung verstärkte
                  Kontrollen, zusätzliche Audits und Prüfungen anordnen. Dies
                  führt zu erhöhtem Verwaltungsaufwand und zusätzlichen Kosten,
                  um die geforderten Sicherheitsmaßnahmen nachzuweisen und
                  umzusetzen.
                </p>
              </div>
            </div>
          </div>

          <div className="white-section">
            <div className="container pt-5">
              <div
                className="safe rounded-2 text-center"
                style={{ backgroundColor: "#fec748" }}
              >
                <img
                  src="/images/abwehr.svg"
                  alt="Abwehr"
                  style={{
                    position: "relative",
                    maxWidth: "7%",
                    height: "auto",
                  }}
                />

                <h3 className="p-5"> Branchenspezifische Schwellenwerte:</h3>

                <p className="col-lg-11 mx-auto">
                  Je nach Sektor werden Schwellenwerte definiert, z. B. die Menge
                  der versorgten Personen oder die Anzahl der angeschlossenen
                  Systeme. Beispielsweise gelten Energieversorger, die mehr als
                  500.000 Haushalte versorgen, als KRITIS-Betreiber.
                  <section class="p-5 text-start">
                    <ul class="timeline">
                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">Energie:</h5>
                        <p>
                          <ul>
                            <li>
                              Stromversorgung: Betreiber, die mehr als 500.000
                              Personen mit Strom versorgen.
                            </li>
                            <li>
                              Gasversorgung: Unternehmen, die mehr als 500.000
                              Personen mit Gas beliefern.
                            </li>
                            <li>
                              Mineralöl: Raffinerien mit einer
                              Verarbeitungskapazität von mehr als 2 Millionen
                              Tonnen pro Jahr.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">Gesundheit:</h5>
                        <p>
                          <ul>
                            <li>
                              Krankenhäuser: Einrichtungen mit mindestens 30.000
                              vollstationären Fällen pro Jahr.
                            </li>
                            <li>
                              Hersteller von Medizinprodukten: Unternehmen,
                              deren Ausfall die Verfügbarkeit lebenswichtiger
                              Produkte gefährden würde.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">
                          Informationstechnik und Telekommunikation:
                        </h5>
                        <p>
                          <ul>
                            <li>
                              Rechenzentren: Einrichtungen mit einer Kapazität
                              von mindestens 5 Megawatt Leistung.
                            </li>
                            <li>
                              Internetknotenpunkte: Betreiber mit einem
                              Datenverkehr von mindestens 300 Gbit/s.
                            </li>
                            <li>
                              Netzbetreiber: Unternehmen, die mehr als 500.000
                              Teilnehmeranschlüsse verwalten.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">Transport und Verkehr:</h5>
                        <p>
                          <ul>
                            <li>
                              Luftverkehr: Flughäfen mit mehr als 50.000 Starts
                              und Landungen pro Jahr.
                            </li>
                            <li>
                              Schienenverkehr: Betreiber mit mindestens 125
                              Millionen Zugkilometern pro Jahr.
                            </li>
                            <li>
                              Schifffahrt: Hafenanlagen mit einem jährlichen
                              Umschlag von mehr als 3 Millionen Tonnen.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">Wasser:</h5>
                        <p>
                          <ul>
                            <li>
                              Wasserversorgung: Unternehmen, die mehr als
                              500.000 Personen versorgen.
                            </li>
                            <li>
                              Abwasserentsorgung: Betreiber mit Kapazitäten für
                              mehr als 500.000 Personen.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">Finanz- und Versicherungswesen:</h5>
                        <p>
                          <ul>
                            <li>
                              Banken: Einrichtungen mit 
                              mehr als 2 Millionen Kunden.
                            </li>
                            <li>
                              Zahlungsdienstleister: Betreiber mit einem
                              Transaktionsvolumen von mehr als 5 Millionen
                              Zahlungen pro Monat.
                            </li>
                            <li>
                              Versicherungen: Anbieter mit einem Beitragsvolumen
                              von mindestens 3 Milliarden Euro pro Jahr.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">Ernährung:</h5>
                        <p>
                          <ul>
                            <li>
                              Lebensmittelproduktion: Unternehmen, die mehr als
                              500 Tonnen pro Tag verarbeiten oder liefern.
                            </li>
                            <li>
                              Großhandel: Lagerhäuser mit einer Kapazität von
                              mehr als 5.000 Tonnen.
                            </li>
                          </ul>
                        </p>
                      </li>

                      <li class="timeline-item mb-5">
                        <h5 class="fw-bold">Chemieindustrie:</h5>
                        <p>
                          <ul>
                            <li>
                              Chemische Anlagen: Produktionsanlagen, deren
                              Ausfall nationale Versorgungsengpässe hervorrufen
                              könnte.
                            </li>
                          </ul>
                        </p>
                      </li>
                    </ul>
                  </section>
                </p>
              </div>
            </div>
          </div>

          {/* Fragenteil */}
          <div className="container pt-5 my-5">
            <div className="text-center m-4">
              <h2>Überprüfe dein Wissen</h2>
              <p className="col-lg-11 mx-auto">
                Mit den richtigen Antworten kommst du weiter!
              </p>
            </div>
            <div className="row justify-content-center">
              <div className="col-md-8">
                <form onSubmit={handleSubmit}>
                  {questions.map((question, index) => (
                    <div key={index} className="mb-4">
                      <p className="fs-4">{question.question}</p>{" "}
                      {question.options.map((option) => (
                        <div key={option.value} className="form-check">
                          <input
                            className="form-check-input me-2"
                            type="radio"
                            name={`question${index}`}
                            value={option.value}
                            checked={selectedAnswers[index] === option.value}
                            onChange={() =>
                              handleAnswerChange(index, option.value)
                            }
                          />
                          <label className="form-check-label fs-5">
                            {option.label}
                          </label>{" "}
                        </div>
                      ))}
                    </div>
                  ))}
                  {error && <p className="text-danger">{error}</p>}
                  <div className="text-center">
                    <button type="submit" className="btn btn-primary">
                      überprüfen
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          {/* Ende Fragenteil */}
        </div>
      </div>
    </div>
  );
};

export default Chapter8_1;
